import { getCookiesAsObject } from '../../../../utils/helpers';

const cookie = getCookiesAsObject();
const user = JSON.parse(cookie?.storageUser);

export const columns = [
  {
    Header: 'Id',
    accessor: 'id',
  },
  {
    Header: 'Task',
    accessor: 'task',
  },
  {
    Header: 'Hours',
    accessor: 'hours',
  },
  {
    Header: 'Cost',
    accessor: 'cost',
  },
  {
    Header: 'Project',
    accessor: 'project_id',
  },
  {
    Header: 'Reporter',
    accessor: 'reporter_name',
  },
  {
    Header: 'Reported Date',
    accessor: 'date_report',
  },
  {
    Header: !['PM'].includes(user?.role) ? 'Actions' : 'Status',
    accessor: !['PM'].includes(user?.role) ? 'actions' : 'status',
    disableSortBy: true,
    disableGlobalFilter: true,
  }
];